import _ from 'lodash'
import resetStore from '../helpers/reset-store'
import axios from 'axios';

export const state = () => ({
  catalogue: {
    my: [],
    full: [],
    manpack: []
  },
  smicustomcatalogues: [],
  gotSmiCats: false,
  customcatalogues: []
})

export const mutations = {
  reset: resetStore(state),
  setCategories(state, categories) {
    // Set initial categories
    if (Array.isArray(categories)) {
      const initData = sortCategories(categories)
 
      state.catalogue = {
        my: initData,
        full: initData,
        manpack: initData
      }
    } else {
      for (let key of Object.keys(categories)) {
        state.catalogue[key] = sortCategories(categories[key])
      }
    }
  },
  setCustomCatalogues(state, catalogues) {
    if (catalogues) {
      state.customcatalogues = catalogues
    } else {
      state.customcatalogues = null
    }
  },
  setSmiCustomCatalogues(state, catalogues) {

    if (catalogues) {
      state.smicustomcatalogues = catalogues
    } else {
      state.smicustomcatalogues = null
    }
  },
  setGotSmiCats(state, value) {
    state.gotSmiCats = value
  }
}

export const actions = {
  async getCategories({ commit }, types) {
    try {
      await Promise.all(
        types.map(type => {
          const params = typeof type === 'object' ? type : { type }
          return axios
            .get('/api/userCategory', {
              params
            })
            .then(res => {
              commit('setCategories', { [params.type]: res.data })
            })
        })
      )
    } catch (e) {
      // Do nothing
    }
  },
  async getCustomCatalogues({ commit }) {
    try {
      await Promise.all(
        axios.get('/api/customCatalogue', {}).then(res => {
          commit('setCustomCatalogues', res.data)
        })
      )
    } catch (e) {
      console.log(e)
    }
  },
  async getSmiCustomCatalogues({ commit, state }) {
    if (state.gotSmiCats) return // Already loaded
    try {
      await axios.get('/api/smiCustomCatalogue', {}).then(res => {
        commit('setSmiCustomCatalogues', res.data)
        commit('setGotSmiCats', true)
      })
    } catch (e) {
      console.log(e)
    }
  },
  async setCategories({ commit }, categories) {
    commit('setCategories', categories)
  }
}

export const getters = {
  fullCatalogueCategories: state => state.catalogue.full,
  myCatalogueCategories: state => state.catalogue.my,
  allCategories(state) {
    return [...state.catalogue.full, ...state.catalogue.my]
  },
  manpackCategories(state) {
    return state.catalogue.manpack
  },
  employeeCatalogues: state => state.customcatalogues,
  smiEmployeeCatalogues(state) {

    if(state.smicustomcatalogues[0]) {
      return state.smicustomcatalogues
    } else {
      return false
    }
  },
  gotSmiCats(state) {
    return state.gotSmiCats
  }
}

/**
 * sortCategories
 * @param  [] categories
 * @return []
 */
const catalogueOrder = {
  1: [21, 22, 26, 24, 25, 104, 105, 28, 29, 103, 127, 113, 27],
  3: [101, 33, 35, 37, 34, 36],
  6: [42, 40, 38, 39, 41, 43, 44],
  117: [119, 118, 121, 120, 123, 124],
  2: [45, 46, 128, 47, 48, 52, 51, 49, 50],
  5: [53, 135, 54, 136, 134, 57, 56, 137, 59, 55, 58],
  19: [61, 60, 63, 64, 65],
  16: [67, 68, 69, 71, 73, 72],
  17: [74, 75, 76],
  18: [77, 78, 80, 79],
  8: [82, 81, 83],
  7: [84, 85, 86, 87],
  11: [89, 92, 88, 94, 93, 90, 91],
  9: [96, 97, 95, 100, 99]
}

function sortCategories(categories) {
  categories = _.sortBy(categories, cate => {
    const ind = _.findIndex(
      Object.keys(catalogueOrder),
      id => id == cate.internalId
    )

    if (ind != -1 && cate.children) {
      cate.children = _.sortBy(cate.children, child => {
        const _ind = _.findIndex(
          catalogueOrder[cate.internalId],
          id => id == child.internalId
        )

        return _ind != -1 ? _ind : 1000
      })
    }

    return ind != -1 ? ind : 1000
  })

  return categories
}

export default {
  namespaced: true, // optional, if you want namespacing
  state,
  mutations,
  actions,
  getters,
};